import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../utils/api";
import { Badge, estadoVisible, mapaEstadosSolicitud } from "../utils/estados";
import { colorAvatar } from "../utils/pagosUi";
import { Ayuda } from "../context/AyudaContext";
import { textoPorMoneda } from "../utils/estados";
import Cargando from "../components/Cargando";

const fecha = (valor) => (valor ? new Date(valor).toLocaleDateString("es-NI") : "—");

// Historial del aprobador: lo que ya aprobó y en qué etapa va cada solicitud
// (pago, compra, retiro, recibida…). Para aprobar lo pendiente, ver
// "Pendientes de Aprobar".
function MisAprobaciones() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [filtro, setFiltro] = useState("");
  const [busqueda, setBusqueda] = useState("");

  const cargar = () => {
    setCargando(true);
    setError("");
    apiFetch("/api/solicitudes/aprobadas-por-mi")
      .then((data) => setSolicitudes(data?.items || []))
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  };

  useEffect(cargar, []);

  const etapaDe = (s) =>
    estadoVisible(s.estado, s.total_cotizaciones, s.tiene_pendiente_aprobacion, s.en_atencion, s.tiene_pago_pendiente, s.tiene_pago_realizado);

  // Cuántas hay en cada etapa — así las pastillas solo muestran lo que existe.
  const conteo = {};
  solicitudes.forEach((s) => {
    const e = etapaDe(s);
    conteo[e] = (conteo[e] || 0) + 1;
  });
  const etapas = Object.keys(conteo);

  const termino = busqueda.trim().toLowerCase().replace("#", "");
  const visibles = solicitudes
    .filter((s) => !filtro || etapaDe(s) === filtro)
    .filter(
      (s) =>
        !termino ||
        String(s.id).padStart(3, "0").includes(termino) ||
        (s.descripcion_requerimiento || "").toLowerCase().includes(termino) ||
        (s.solicitante_nombre || "").toLowerCase().includes(termino) ||
        s.proveedores.some((p) => p.toLowerCase().includes(termino))
    );

  const enCurso = solicitudes.filter((s) => !["entregada", "rechazada"].includes(etapaDe(s))).length;
  const recibidas = conteo.entregada || 0;
  // Un total por moneda (cada solicitud trae sus montos en la moneda de su cotización).
  const montosDe = (s) => s.montos_por_moneda || { NIO: Number(s.monto_aprobado || 0) };
  const montoTotal = solicitudes.reduce((acc, s) => {
    Object.entries(montosDe(s)).forEach(([m, v]) => {
      acc[m] = (acc[m] || 0) + Number(v);
    });
    return acc;
  }, {});

  const TARJETAS = [
    { texto: "Solicitudes aprobadas", valor: solicitudes.length, icono: "🗂️", color: "#3d5a99", bg: "#e1e7f5" },
    { texto: "En curso", valor: enCurso, icono: "🚚", color: "#b85a0b", bg: "#fde6cf" },
    { texto: "Recibidas", valor: recibidas, icono: "✅", color: "#2f7a54", bg: "#dcf0e6" },
    { texto: "Monto aprobado", valor: textoPorMoneda(montoTotal), icono: "💰", color: "var(--tema-titulo, #0b3c60)", bg: "var(--tema-suave, #dceaf5)" },
  ];

  return (
    <div>
      <Link to="/pendientes" style={styles.volver}>
        ← Regresar a Aprobaciones
      </Link>
      <h2 style={{ margin: 0, color: "var(--tema-titulo, #0b3c60)", textAlign: "center" }}>🗂️ Mis aprobaciones</h2>
      <Ayuda>
        <p style={{ color: "#5b6472", marginTop: "0.25rem", fontSize: "0.9rem", textAlign: "center" }}>
          Las solicitudes en las que ya aprobaste productos y en qué etapa va cada una.
        </p>
      </Ayuda>

      {error && <p style={{ color: "#a3402f", marginTop: "1rem" }}>{error}</p>}

      {cargando ? (
        <Cargando compacto />
      ) : solicitudes.length === 0 && !error ? (
        <div style={styles.vacio}>
          <div style={{ fontSize: "2rem" }}>🗂️</div>
          <h3 style={{ margin: "0.4rem 0 0.2rem", color: "var(--tema-titulo, #0b3c60)" }}>Todavía no has aprobado nada</h3>
          <p style={{ margin: 0, color: "#5b6472", fontSize: "0.88rem" }}>
            Cuando apruebes una compra, aparecerá aquí con su estado.
          </p>
        </div>
      ) : (
        <>
          <div className="tarjetas-resumen" style={styles.tarjetas}>
            {TARJETAS.map((t) => (
              <div key={t.texto} style={styles.tarjeta}>
                <div style={{ ...styles.iconoTarjeta, background: t.bg, color: t.color }}>{t.icono}</div>
                <div>
                  <div style={styles.tarjetaValor}>{t.valor}</div>
                  <div style={styles.tarjetaTexto}>{t.texto}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="barra-filtros" style={styles.barra}>
            <input
              type="text"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              placeholder="Buscar por número, solicitante, proveedor…"
              style={styles.buscador}
            />
            <div style={styles.pills}>
              <button
                type="button"
                onClick={() => setFiltro("")}
                style={{ ...styles.pill, ...(filtro === "" ? styles.pillActivo : {}) }}
              >
                Todas ({solicitudes.length})
              </button>
              {etapas.map((e) => (
                <button
                  key={e}
                  type="button"
                  onClick={() => setFiltro(e)}
                  style={{ ...styles.pill, ...(filtro === e ? styles.pillActivo : {}) }}
                >
                  {mapaEstadosSolicitud()[e]?.texto || e} ({conteo[e]})
                </button>
              ))}
            </div>
          </div>

          {visibles.length === 0 ? (
            <p style={{ color: "#5b6472", textAlign: "center", marginTop: "1.5rem" }}>
              No hay solicitudes con ese filtro.
            </p>
          ) : (
            <div style={styles.tarjetaTabla}>
              <div className="table-scroll">
                <table style={styles.tabla}>
                  <colgroup>
                    <col style={{ width: 4 }} />
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "10%" }} />
                    <col style={{ width: "16%" }} />
                    <col />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "13%" }} />
                    <col style={{ width: "8%" }} />
                  </colgroup>
                  <thead>
                    <tr style={{ borderBottom: "1px solid #d3d9df" }}>
                      <th style={styles.thAcento}></th>
                      <th style={{ ...styles.th, textAlign: "center" }}>Solicitud</th>
                      <th style={{ ...styles.th, textAlign: "center" }}>Aprobada el</th>
                      <th style={styles.th}>Solicitante</th>
                      <th style={styles.th}>Requerimiento</th>
                      <th style={styles.th}>Proveedor</th>
                      <th style={{ ...styles.th, textAlign: "right" }}>Monto aprobado</th>
                      <th style={{ ...styles.th, textAlign: "center" }}>Estado</th>
                      <th style={{ ...styles.th, textAlign: "center" }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visibles.map((s, i) => {
                      const etapa = etapaDe(s);
                      return (
                        <tr
                          key={s.id}
                          className="fila-hover"
                          style={{ borderBottom: "1px solid #eef1f3", background: i % 2 === 1 ? "#fafbfc" : "#fff" }}
                        >
                          <td style={{ ...styles.tdAcento, background: mapaEstadosSolicitud()[etapa]?.color || "#d3d9df" }}></td>
                          <td style={{ ...styles.td, textAlign: "center", whiteSpace: "nowrap" }}>
                            <Link to={`/aprobadas/${s.id}`} style={styles.linkFolio}>
                              #{String(s.id).padStart(3, "0")}
                            </Link>
                          </td>
                          <td style={{ ...styles.td, textAlign: "center", whiteSpace: "nowrap" }}>{fecha(s.mi_aprobacion_en)}</td>
                          <td style={styles.td}>
                            <div style={styles.celdaPersona}>
                              <span style={{ ...styles.avatar, background: colorAvatar(s.solicitante_nombre) }}>
                                {(s.solicitante_nombre || "?").charAt(0).toUpperCase()}
                              </span>
                              <div>
                                {s.solicitante_nombre}
                                <div style={styles.subtexto}>{s.area_nombre}</div>
                              </div>
                            </div>
                          </td>
                          <td style={{ ...styles.td, lineHeight: 1.35 }}>
                            <div style={styles.requerimiento}>{s.descripcion_requerimiento}</div>
                          </td>
                          <td style={styles.td}>
                            {s.proveedores.map((p) => (
                              <div key={p} style={styles.celdaPersona}>
                                <span style={{ ...styles.avatar, background: colorAvatar(p) }}>
                                  {p.charAt(0).toUpperCase()}
                                </span>
                                <span style={{ fontWeight: 600 }}>{p}</span>
                              </div>
                            ))}
                          </td>
                          <td
                            style={{
                              ...styles.td,
                              textAlign: "right",
                              fontWeight: 700,
                              whiteSpace: "nowrap",
                              fontVariantNumeric: "tabular-nums",
                            }}
                          >
                            {textoPorMoneda(montosDe(s))}
                          </td>
                          <td style={{ ...styles.td, textAlign: "center" }}>
                            <Badge estado={etapa} mapa={mapaEstadosSolicitud()} />
                          </td>
                          <td style={{ ...styles.td, textAlign: "center" }}>
                            <Link to={`/aprobadas/${s.id}`} style={styles.botonDetalle}>
                              👁 Ver
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const styles = {
  volver: { color: "var(--tema-titulo, #0b3c60)", fontWeight: 600, fontSize: "0.88rem", textDecoration: "none" },
  vacio: {
    marginTop: "1.5rem",
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "2.5rem 1.5rem",
    background: "#fff",
    textAlign: "center",
  },
  tarjetas: { display: "flex", flexWrap: "wrap", gap: "0.8rem", marginTop: "1.2rem" },
  tarjeta: {
    flex: "1 1 200px",
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    border: "1px solid #e2e6ea",
    borderRadius: 12,
    padding: "0.8rem 1rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
  },
  iconoTarjeta: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
    flexShrink: 0,
  },
  tarjetaValor: { fontSize: "1.2rem", fontWeight: 700, color: "var(--tema-titulo, #0b3c60)", fontVariantNumeric: "tabular-nums" },
  tarjetaTexto: { fontSize: "0.76rem", color: "#5b6472" },
  barra: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.7rem",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "1.2rem",
  },
  pills: { display: "flex", gap: "0.4rem", flexWrap: "wrap" },
  pill: {
    border: "1px solid #d3d9df",
    background: "#fff",
    color: "#5b6472",
    borderRadius: 999,
    padding: "0.35rem 0.85rem",
    fontSize: "0.8rem",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  pillActivo: { background: "var(--tema-titulo, #0b3c60)", borderColor: "var(--tema-titulo, #0b3c60)", color: "#fff" },
  buscador: {
    minWidth: 260,
    flex: "0 1 380px",
    padding: "0.45rem 0.7rem",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    fontFamily: "inherit",
    fontSize: "0.85rem",
  },
  tarjetaTabla: {
    marginTop: "1rem",
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
    overflow: "hidden",
  },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.86rem", tableLayout: "fixed", minWidth: 1000 },
  th: {
    padding: "0.65rem 0.75rem",
    background: "#eef1f3",
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "var(--tema-titulo, #0b3c60)",
    textAlign: "left",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    whiteSpace: "nowrap",
    borderLeft: "1px solid #e3e8ee",
    borderRight: "1px solid #e3e8ee",
  },
  td: {
    padding: "0.7rem 0.75rem",
    verticalAlign: "middle",
    color: "var(--tema-titulo, #0b3c60)",
    borderLeft: "1px solid #eef1f3",
    borderRight: "1px solid #eef1f3",
  },
  tdAcento: { padding: 0, width: 4 },
  thAcento: { padding: 0, width: 4, background: "#eef1f3", border: "none" },
  celdaPersona: { display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.2rem" },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: "50%",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.7rem",
    fontWeight: 700,
    flexShrink: 0,
  },
  linkFolio: { color: "var(--tema-primario, #2f6690)", fontWeight: 800, textDecoration: "none" },
  // Dos líneas como máximo: un requerimiento largo no estira la fila.
  requerimiento: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  subtexto: { fontSize: "0.74rem", color: "#8993a1" },
  listaProductos: { margin: "0.35rem 0 0", paddingLeft: "1.1rem", fontSize: "0.78rem", color: "#5b6472" },
  avisoPendientes: { marginTop: "0.35rem", fontSize: "0.74rem", fontWeight: 700, color: "#b85a0b" },
  botonDetalle: {
    display: "inline-block",
    background: "var(--tema-titulo, #0b3c60)",
    color: "#fff",
    borderRadius: 8,
    padding: "0.4rem 0.8rem",
    fontSize: "0.8rem",
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "nowrap",
  },
};

export default MisAprobaciones;
